import {getSessionDetails} from '@albert-io/mandark/authentication/sessionDetails';

import {getResponseStatus} from 'lib/normalizeError';

export const isUnauthenticated = (error: unknown): boolean => getResponseStatus(error) === 401;

/** Asks the server whether the session cookie still signs the user in, for deciding what a 401 means. */
export async function sessionStillValid(): Promise<boolean> {
  try {
    const response = await getSessionDetails();
    return response.status === 200 && Boolean(response.body?.user);
  } catch (error) {
    // Only the session endpoint refusing means the cookie is dead; a 5xx or a dropped connection earns the retry.
    return !isUnauthenticated(error);
  }
}
